import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import App from "./App";
import 'rsuite/dist/rsuite.min.css';
import { Provider } from "react-redux";
import configureStore from "./store";
import { MsalProvider as MsalReactProvider } from "@azure/msal-react";
import {msalInstance} from "./utils/auth";

export const store = configureStore();

const container = document.getElementById("root");
const root = ReactDOM.createRoot(container);

root.render(
  // <React.StrictMode>
  <Provider store={store}>
    <BrowserRouter>
      <MsalReactProvider instance={msalInstance}>
        <App pca={msalInstance} />
      </MsalReactProvider>
    </BrowserRouter>
  </Provider>
  // </React.StrictMode>
);
